<h1 class="text-dark text-xl" mat-dialog-title>Copia mese Tutti i codici</h1>
<div class="w-full" mat-dialog-content>
  <app-ms-duplicate-form [data]="selection" [modalTrigger$]="modalTrigger"></app-ms-duplicate-form>
</div>
